import { Filter } from '@anytag/shared-molecules';
import { useTwitterInfluencersContext } from '../TwitterInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const TwitterInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage, isPackagePage } = useTwitterInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
